import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <i className="fas fa-cut"></i>
              <span>BukkyDebrand</span>
            </div>
            <p>Premium hair brand at Ekumi Plaza. We provide quality wigs, weaves, and wig-making supplies to help you achieve your perfect look.</p>
            <div className="social-links">
              <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="#" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Products</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Products</h4>
            <ul>
              <li><a href="#services">Premium Wigs</a></li>
              <li><a href="#services">Hair Weaves</a></li>
              <li><a href="#services">Wig Making Supplies</a></li>
              <li><a href="#services">Hair Care Products</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <span>Ekumi Plaza (New York Line)</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <span>09067075926</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <span>info@bukkydebrand.com</span>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 BukkyDebrand. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;